import styled from 'styled-components';
import { rem } from 'polished';
import mediaqueries from '../../../config/themes/variables/mediaqueries';

const StyledFormatTxt = styled.a`
  background-color: ${props => props.theme.colors.light};
  color: ${props => props.theme.colors.dark};
  display: block;
  font: ${rem('10px')} / ${rem('13px')} ${props => props.theme.fonts.bold};
  padding: ${rem('3px')} ${rem('3px')};
  text-align: center;
  text-transform: uppercase;
  transition: 0.5s;
  &:hover {
    background-color: ${props => props.theme.colors.primary};
  }
  ${mediaqueries.greaterThan('mobile')`
      background-color: ${props => props.theme.colors.dark};
      color: ${props => props.theme.colors.light};
  `};
`;

export { StyledFormatTxt };
